import { HTMLAttributeAnchorTarget } from "react";
import { useTranslation } from "react-i18next";

import { Button, Card, Typography } from "@digital-services/ui";

import { ApplicationJsonModel } from "@applications/models/ApplicationJsonModel";

import abbIcon from "@icons/abb.svg";

import { AppEnv } from "./AppEnv";

interface Props {
  application: ApplicationJsonModel;
  target?: HTMLAttributeAnchorTarget;
  className?: string;
}

export function QuickAccessTile(props: Readonly<Props>) {
  const { application, target, className } = props;

  const { t } = useTranslation(undefined, {
    keyPrefix: "button"
  });

  let cssClassNames =
    "grid h-[75px] w-[365px] grid-cols-1 place-content-center place-items-center gap-1 p-2";

  if (className) {
    cssClassNames += " " + className;
  }

  return (
    <Card
      className={cssClassNames}
      data-testid={`quick-access-tile-card-${application.id}`}
    >
      <div className="flex h-full w-full">
        <div className="mr-3 justify-start">
          <div
            data-testid="application-logo-container"
            className="h-[50px] w-[50px] place-content-center place-items-center rounded-lg border-2 border-gray-200"
          >
            <img
              className="rounded-lg border-transparent"
              width="48px"
              src={application.logoUrl ?? abbIcon}
              alt="application logo"
              data-testid="application-logo-image"
            />
          </div>
        </div>
        <div
          className="mr-3 flex h-full w-full flex-col justify-start p-px"
          data-testid="application-info"
        >
          <Typography variant="smallTitle" className="w-[185px] truncate">
            {application.name}
          </Typography>

          {application.appEnv ? <AppEnv value={application.appEnv} /> : null}

          <Typography variant="smallText">{application.subTitle}</Typography>
        </div>
        <div
          data-testid="application-open-button"
          className="place-content-center justify-end p-px"
        >
          <Button
            data-testid={`open-${application.id}-application`}
            className="cursor-pointer"
            onClick={() => {
              globalThis.open(application.url, target);
            }}
          >
            {t("open.label")}
          </Button>
        </div>
      </div>
    </Card>
  );
}
